import React from "react";
import { Grid } from "@mui/material";
import MenuItem from "./../MenuItem/MenuItem";

const NavBar = (props) => {
  const { menu } = props;

  
  if (menu && menu.length === 1 && menu[0].subMenus && menu[0].subMenus.length === 1) {
    return null;
  }

  return (
    <Grid container>
      {menu && menu.length
        ? menu.map((menuItem) => {
            return (
              <Grid item key={menuItem.key}>
                <MenuItem subMenu={menuItem} />
              </Grid>
            );
          })
        : null}
    </Grid>
  );
};

export default NavBar;
